<template>
  <div class="full-page not-has-footer cancellation-page">
    <div class="cancellation">
      <template v-if="isSuccess">
        <img
          :src="
            require('@/assets/icon/studio7/icon-check-circle.svg')
          "
          width="48"
          height="48"
        />
        <h1 class="headline-l">ยกเลิกสำเร็จ</h1>
        <p class="body-s">
          ระบบทำการยกเลิกความสนใจของคุณเรียบร้อยแล้ว
          หากคุณยังประสงค์ให้ระบบแจ้งเตือนเมื่อสินค้าเปิดจอง
          สามารถลงทะเบียนความสนใจใหม่ได้จนถึงวันที่ 10 กันยายน 2569
          เวลา 12.00 น.
        </p>
        <v-btn
          v-if="rebookUrl"
          color="primary"
          depressed
          :loading="isLoading"
          @click="onRebookAgain"
        >
          ทำรายการใหม่อีกครั้ง
        </v-btn>
      </template>

      <template v-else>
        <h1 class="headline-l">ยืนยันยกเลิกความสนใจ</h1>
        <p class="body-s">
          การยกเลิกนี้ไม่สามารถย้อนกลับได้ ยืนยันยกเลิกหรือไม่ ?
        </p>
        <v-btn
          color="error"
          depressed
          :loading="isLoading"
          @click="onConfirmCancel"
        >
          ยืนยันการยกเลิก
        </v-btn>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Cancellation',

  computed: {
    cancelData() {
      return this.$store.state.order.cancelVipOrder?.data
    },
    isLoading() {
      return this.$store.getters['order/isLoading']('cancelVipOrder')
    },
    isSuccess() {
      return this.$store.getters['order/isSuccess']('cancelVipOrder')
    },
    isError() {
      return this.$store.getters['order/isError']('cancelVipOrder')
    },
    errorMessage() {
      return this.$store.getters['order/errorMessage'](
        'cancelVipOrder',
      )
    },
    rebookUrl() {
      return this.cancelData?.redirect_url ?? null
    },
  },

  methods: {
    onRebookAgain() {
      window.location.href = this.rebookUrl
    },
    async onConfirmCancel() {
      const { uuid } = this.$route.params
      const { token } = this.$route.query

      await this.$store.dispatch('order/cancelVipOrder', {
        uuid,
        code: token,
      })
    },
  },
}
</script>

<style lang="stylus" scoped>
.cancellation-page {
  display: flex;
  align-items: center;
  justify-content: center;
}
.cancellation {
  max-width: 480px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 16px;
  padding: 24px;
}
</style>
